<script>
	import { user } from '../models/user.js';
</script>

<div class="user-nav">
	<section class="user-info">
		Hello there!
	</section>

	<ul class="user-links">
		{#if $user && $user.username}
		<li><a class="nav-link link-plain" href="/account">My Account</a></li>
		<li>
			<a class="nav-link link-plain" href="/logout" rel="external">
				Logout <svg class="icon"><use href="/icons.svg#logout"></use></svg>
			</a>
		</li>
		{:else}
		<li class="btn-group-expanded">
			<a class="btn" href="/login?referrer={window.location.pathname}">Sign In</a>
			<a class="btn" href="/register">Register</a>
		</li>
		{/if}
	</ul>
</div>

<style>
	.user-nav{
		display: flex;
		flex-direction: column;
		padding: 0 var(--spacing-sm);
	}

	.user-info{
		line-height: calc(var(--line-height) * 2);
	}

	.user-orders{
		border-top: solid 1px var(--col-accent-2);
	}

	.user-links{
		padding: var(--spacing-sm) 0;
		margin: 0;
		list-style: none;
		border-top: solid 1px var(--col-accent-2);
	}

	.nav-link{
		display: block;
		box-sizing: border-box;
		height: calc(var(--line-height) * 2);
		line-height: calc(var(--line-height) * 2);
	}

	.user-order{
		display: flex;
		align-items: center;
		justify-content: space-between;
		line-height: calc(var(--line-height) / 1.5);
		padding: calc(var(--line-height) / 3) 0;
	}
	.user-order .icon{
		font-size: 1.5rem;
	}
	.order-info{
		display: flex;
		flex-direction: column;
	}
	.order-num{
		font-weight: 600;
	}
	.order-status{
		font-size: .9rem;
	}
</style>
